export default "__VITE_ASSET__BBGzME3z__"